import {
  GALLERY_IMAGE_UPLOAD_REQUEST,
  GALLERY_IMAGE_UPLOAD_SUCCESS,
  GALLERY_IMAGE_UPLOAD_FAIL,
  GALLERY_IMAGE_FETCH_REQUEST,
  GALLERY_IMAGE_FETCH_SUCCESS,
  GALLERY_IMAGE_FETCH_FAIL,
  GALLERY_IMAGE_DELETE_REQUEST,
  GALLERY_IMAGE_DELETE_SUCCESS,
  GALLERY_IMAGE_DELETE_FAIL,
} from "../../constants/admin/galleryConstants";

const initialState = {
  loading: false,
  success: false,
  error: null,
  images: [],
  message: null,
};

// Single Reducer for gallery images Actions
export const galleryImageReducer = (state = initialState, action) => {
  switch (action.type) {
      case GALLERY_IMAGE_UPLOAD_REQUEST:
      case GALLERY_IMAGE_FETCH_REQUEST:
      case GALLERY_IMAGE_DELETE_REQUEST:
          return { ...state, loading: true, success: false, error: null };

      case GALLERY_IMAGE_UPLOAD_SUCCESS:
          return { ...state, loading: false, success: true, images: action.payload.images };

      case GALLERY_IMAGE_FETCH_SUCCESS:
          return { ...state, loading: false, images: action.payload.gallery };

      case GALLERY_IMAGE_DELETE_SUCCESS:
          return { ...state, loading: false, success: true, message: action.payload.message };

      case GALLERY_IMAGE_UPLOAD_FAIL:
      case GALLERY_IMAGE_FETCH_FAIL:
      case GALLERY_IMAGE_DELETE_FAIL:
          return { ...state, loading: false, error: action.payload };

      default:
          return state;
  }
};
